import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { BaseHttpService } from 'src/app/service/base-http.service';

@Component({
  selector: 'app-dev-manufacturer-list',
  templateUrl: './dev-manufacturer-list.component.html',
  styleUrls: ['./dev-manufacturer-list.component.css']
})
export class DevManufacturerListComponent implements OnInit {
	error=null
	loading = false
	hasEditPerm = false;
	devManufacturerList=null
	devManufacturerPagination={
		currentPage:1,
		pageSize:10,
		pageCount:0,
		rowCount:0,
		pageList:null
	}
	searchForm: FormGroup=this.formBuilder.group({
		nameLike: ['' ,[ Validators.maxLength(200)] ],
		status: [null ]
	});
	manufacturerStatusOptionList=[
		{ value : null, label : "Tất cả" },
		{ value : 0, label : "Ngừng sử dụng" },
		{ value : 1, label : "Sử dụng" }
	]
	manufacturerStatusOptionMap={}
	constructor(private authService: AuthService,private formBuilder: FormBuilder,
	private httpService:BaseHttpService,
	private route: ActivatedRoute,
	private router: Router ) { }
	ngOnInit(): void {
		this.authService.hasAnyPerm(['DEV_MANUFACTURER']).subscribe(hasPerm => {
		  this.hasEditPerm = hasPerm;
		})
		for(var manufacturerStatusOption of this.manufacturerStatusOptionList){
			this.manufacturerStatusOptionMap[manufacturerStatusOption.value]=manufacturerStatusOption.label;
		}
		this.searchManufacturer();
	}

	devManufacturerPageChange(page){
		if(this.loading){
			return;
		}
    this.error=null;
		var searchFormData=this.searchForm.getRawValue()
		var findRequest:any = {}
		var nameLike = searchFormData["nameLike"];
		if(nameLike){
			findRequest.nameLike= `%${nameLike}%`;
		}
		var status = searchFormData["status"];
		if(status !== null){
			findRequest.status= status;
		}
		if(page<1){
			page=1
		}
		findRequest.queryOffset=(page-1)*this.devManufacturerPagination.pageSize;
		findRequest.queryLimit=this.devManufacturerPagination.pageSize;
		this.loading=true;
		this.httpService.post<any>(`/api/admin/dev/manufacturer/search`,findRequest).subscribe(findOtpManufacturerResponse=>{
            this.loading=false;
			var rowCount = findOtpManufacturerResponse.rowCount;
			var pageCount = Math.ceil(rowCount/this.devManufacturerPagination.pageSize);
			var pageList=[]
			for(var i=page-2;i<=page+2;i++){
				if(i>=1&&i<=pageCount){
					pageList.push(i);
				}
			}
			this.devManufacturerPagination.currentPage=page;
			this.devManufacturerPagination.rowCount=rowCount;
			this.devManufacturerPagination.pageCount=pageCount;
			this.devManufacturerPagination.pageList=pageList;
			this.devManufacturerList= findOtpManufacturerResponse.resultList;
		},errorResponse=>{
            this.loading=false;
			if(errorResponse.status==403){
			  this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
			  return;
			}
      if(errorResponse.status>0){
        if(errorResponse.error?.errorCode){
          this.error=errorResponse.error.errorCode+(errorResponse.error.errorMessage?":"+errorResponse.error.errorMessage:"");
          return;
        }
        this.error=errorResponse.status+":"+errorResponse.error.error+(errorResponse.error.message?":"+errorResponse.error.message:"");
        return;
      }
      this.error="Lỗi kết nối! Vui lòng thử lại sau";
		});
	}
	searchManufacturer(){
		this.devManufacturerPageChange(1);
	}
	viewManufacturer(devManufacturer){
		this.router.navigate(['view',devManufacturer.id],{ relativeTo: this.route })
	}
	insertManufacturer(){
		this.router.navigate(['create'],{ relativeTo: this.route })
	}
	editManufacturer(devManufacturer){
		this.router.navigate(['edit',devManufacturer.id],{ relativeTo: this.route })
	}
	deleteManufacturer(devManufacturer){
		this.router.navigate(['delete',devManufacturer.id],{ relativeTo: this.route })
	}
}


